module.exports = __webpack_public_path__ + "img/stains1.743ff7fd.png";